import { useState } from 'react'
import { getStaticText } from '../../../lables/lablesService';

const useValidateTable = () => {
    const [errors, setErrors] = useState({});

    //Input field validation method
    const handleValidation = (fields) => {

        let errors = {};
        let formIsValid = true;

        if (fields) {
            if (!fields['name']) {
                formIsValid = false;
                errors['name'] = getStaticText('lng_required_field');
            }

            if (!fields['iso']) {
                formIsValid = false;
                errors['iso'] = getStaticText('lng_required_field');
            }

            if (!fields['flag']) {
                formIsValid = false;
                errors['flag'] = getStaticText('lng_required_field');
            }
        }

        setErrors(errors);

        setTimeout(() => {
            setErrors("");
        }, 3000)

        return formIsValid;
    };

    //Validate value
    const validateValue = {
        errors,
        handleValidation
    }

    return validateValue;
}

export default useValidateTable;